import { APP_BASE_HREF } from "@angular/common";
import { Component, Inject, OnInit, OnDestroy } from "@angular/core";

@Component({
    selector: 'home',
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.css']
})

export class HomeComponent implements OnInit, OnDestroy {
    constructor(
        @Inject(APP_BASE_HREF) public baseHref: string) {
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
    }
}
